type CardItemProps = {
  label: string | React.ReactNode
  value: string | number | React.ReactNode
}

export function CardItem({ label, value }: CardItemProps) {
  return (
    <div className='flex justify-between gap-x-4 py-1 min-h-[26px]'>
      <dt className='font-light text-zinc-800 dark:text-zinc-300'>
        {label}:
      </dt>
      <dd className='truncate font-medium'>
        {value}
      </dd>
    </div>
  )
}